import React from "react";
import LocationContainer from "./components/Steps/Location/LocationContainer";
import TeamContainer from "./components/Steps/Team/TeamContainer";
import VarietyContainer from "./components/Steps/Variety/VarietyContainer";
import TargetContainer from "./components/Steps/Target/TargetContainer";
import ProjectContainer from "./components/Steps/Project/ProjectContainer";
import DeadlineContainer from "./components/Steps/Deadline/DeadlineContainer";
import ContactContainer from "./components/Steps/Contact/ContactContainer";
import {BrowserRouter, Route, Switch} from "react-router-dom";

import ReportContainer from "./components/Report/ReportContainer";

/**
 *
 * * Steps ID Information
 *
 * Location: 1 - User Location Identification
 * Variety:  2 - Type Of Calculation (Team/Project)
 * Target:   3 - Location Of Team/Project
 * Team:     4 - Team Calculation
 * Project:  5 - Project Calculation
 * Deadline: 6 - Deadline Of Team/Project
 * Contact:  7 - Contact Form
 */

function renderSwitch(currentStep) {
            switch (currentStep) {
                case 1:
                    return <LocationContainer/>; //User Location Identification
                case 2:
                    return <VarietyContainer/>; //Type Of Calculation (Team/Project)
                case 3:
                    return <TargetContainer/>;
                case 4:
                    return <TeamContainer/>; //Team Calculation
                case 5:
                    return <ProjectContainer/>;
                case 6:
                    return <DeadlineContainer/>; //Deadline Of Team/Project
                case 7:
                    return <ContactContainer/>; //Contact Form
            }
}

let App = (props) => {
    return (
        <>
            <BrowserRouter>
                <Switch>
                    <Route path="/report/:id" component={ReportContainer} />
                    <Route>
                        <div className={"interface"}>
                        {renderSwitch(props.flow.nextStep)}
                        </div>
                    </Route>
                </Switch>
            </BrowserRouter>

        </>
    );
};

export default App;